import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-decoration",
  "use": "icon-decoration-usage",
  "viewBox": "0 0 220 220",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 220 220\" id=\"icon-decoration\"><path d=\"M111.44,42.72a4.5,4.5,0,0,0-6.36-6.36L35.69,105.75a4.5,4.5,0,1,0,6.36,6.36Z\" /><path d=\"M44.77,180.4A4.51,4.51,0,0,0,48,179.09L178.42,48.62a4.5,4.5,0,1,0-6.37-6.37L41.58,172.72a4.5,4.5,0,0,0,3.19,7.68Z\" /><path d=\"M157,185a28.61,28.61,0,1,0-28.61-28.61A28.65,28.65,0,0,0,157,185Zm0-48.22a19.61,19.61,0,1,1-19.61,19.61A19.63,19.63,0,0,1,157,136.74Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol